module.exports = __webpack_public_path__ + "img/outlook.963256f2.svg";